import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { PlacementInfo } from '../offers.types';
import { OfferStatusIndicatorComponent } from './../offer-status-indicator/offer-status-indicator.component';
@Component({
  selector: 'rt-offer-info-box',
  templateUrl: './offer-info-box.component.html',
  styleUrls: ['./offer-info-box.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OfferStatusIndicatorComponent],
})
export class OfferInfoBoxComponent {
  @Input() public info: PlacementInfo;
}
